import { PropTypes } from 'prop-types';
import React, { useEffect, useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Button } from '@ge/components/button';
import { Icons } from '@ge/components/icon';
import { useCustomFilterCount } from '@ge/feat-manage/data-hooks/use-custom-filter-count';
import { TaskTrackers, DefaultFiltersView } from '@ge/models/constants';
import { EntityDetailsContext } from '@ge/shared/context/entity-details-context';
import { globalColors } from '@ge/tokens';

import FavoriteIcon from './favourite.svg';
import { ListIcon } from './tasks-tracker';
const TaskTrackerName = styled.span`
  font-size: 11px;
  letter-spacing: 0.5px;
  line-height: 13px;
  text-align: center;
  margin: 0px;
`;

const TaskTrackerCount = styled.p`
  font-size: 16px;
  letter-spacing: -0.33px;
  line-height: 19px;
  text-align: center;
  margin: 0px;
`;

const FilterButton = ({
  taskTracker,
  handleClick,
  tasksTrackerCount,
  identifier,
  enableReorder,
  handleDrag,
  handleDrop,
  handleDragOver,
  isTasksLoading,
  loadCompletedTasks,
  filters,
}) => {
  const { t } = useTranslation(['tasks'], { useSuspense: false });
  const { getTaskCount, filterTask } = useCustomFilterCount();
  const { customView, setCustomView, isCustomFilterSelected, setIsCustomFilterSelected } =
    useContext(EntityDetailsContext);

  useEffect(() => {
    if (!taskTracker.defaultView) {
      getTaskCount(taskTracker);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskTracker]);

  useEffect(() => {
    const defaultView = DefaultFiltersView.includes(taskTracker?.id);
    const isCustomView = !defaultView && taskTracker?.selected === true;
    if (isCustomView) {
      setCustomView(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskTracker]);

  useEffect(() => {
    const defaultView = DefaultFiltersView.includes(taskTracker?.id);
    const isCustomView = !defaultView && taskTracker?.selected === true;
    const filterNotApplied =
      filters && Object.values(filters)?.every((value) => value?.value === null);
    if (isCustomView && filterNotApplied) {
      setIsCustomFilterSelected(true);
    }
  }, [filters, setIsCustomFilterSelected, taskTracker]);

  const handleBtnClick = useCallback(() => {
    const defaultView = DefaultFiltersView.includes(taskTracker?.id);
    const isCustomView = !defaultView && taskTracker?.selected === true;
    if (isCustomView) {
      setCustomView(true);
    }
    if (!enableReorder) {
      setTimeout(() => {
        handleClick(taskTracker);
      }, 0);
    }
  }, [enableReorder, handleClick, setCustomView, taskTracker]);

  useEffect(() => {}, [customView]);
  useEffect(() => {}, [isCustomFilterSelected]);

  return (
    <div
      draggable={enableReorder}
      onDrag={(event) => handleDrag(event, taskTracker, identifier)}
      onDrop={(event) => handleDrop(event, taskTracker)}
      onDragOver={(event) => handleDragOver(event, identifier)}
    >
      <Button
        key={taskTracker?.id}
        onClick={handleBtnClick}
        className={`taskTrackerBtn ${taskTracker?.selected ? 'selected' : ''} 
        ${identifier === 0 ? TaskTrackers.FIRST_TRACKER_BTN : ''} ${
          enableReorder ? TaskTrackers.DRAG_TASK_TRACKER : ''
        }`}
      >
        {!taskTracker?.defaultView && !enableReorder ? (
          <img
            src={FavoriteIcon}
            alt={t('tasks_tracker.fav_icon', 'favorite-icon')}
            className="fav-icon"
          />
        ) : (
          enableReorder && (
            <ListIcon
              icon={Icons.LIST}
              color={taskTracker?.selected ? globalColors.white : globalColors.slate3}
              size={11}
            />
          )
        )}
        {}
        <TaskTrackerName>
          {t(`tasks_tracker.${taskTracker?.id}`, taskTracker?.name)}
        </TaskTrackerName>
        {!isTasksLoading ? (
          !loadCompletedTasks &&
          (taskTracker?.name === 'RECENTLY CLOSED' || taskTracker?.name === 'ALL COMPLETED') ? (
            <TaskTrackerCount>-</TaskTrackerCount>
          ) : (
            <TaskTrackerCount>
              {!taskTracker.defaultView && filterTask
                ? filterTask?.length
                : tasksTrackerCount[taskTracker?.name]}
            </TaskTrackerCount>
          )
        ) : (
          <TaskTrackerCount>-</TaskTrackerCount>
        )}
      </Button>
    </div>
  );
};

FilterButton.propTypes = {
  taskTracker: PropTypes.object,
  handleClick: PropTypes.func,
  tasksTrackerCount: PropTypes.object,
  identifier: PropTypes.number,
  enableReorder: PropTypes.bool,
  handleDrag: PropTypes.func,
  handleDrop: PropTypes.func,
  handleDragOver: PropTypes.func,
  isTasksLoading: PropTypes.bool,
  loadCompletedTasks: PropTypes.bool,
  filters: PropTypes.object,
};

export default FilterButton;
